let idCount = 0;

export function uniqueId() {
    return ++idCount;
}